import { Icons, WalletIcons } from "rujira.ui";
import { useAccounts } from "../../services/accounts";
import { WalletOption, WalletOptionType } from "./WalletOption";
const { Discord, GitHub, LinkConnect, Telegram, X } = Icons;

const options: WalletOptionType[] = [
  {
    description:
      "Get best-in-class security from the most secure crypto wallet ever built, powered by the technology protecting multimillion dollar vaults on Thorchain. Perfect for individuals, DAOs and Teams seeking multi-sig functionality.",
    links: [
      {
        url: "https://vultisig.com",
        icon: <LinkConnect />,
      },
      {
        url: "https://twitter.com/vultisig",
        icon: <X />,
      },
      {
        url: "https://github.com/Vultisig/",
        icon: <GitHub />,
      },
      {
        url: "https://discord.gg/54wEtGYxuv",
        icon: <Discord />,
      },
      {
        url: "https://t.me/vultisig",
        icon: <Telegram />,
      },
    ],
    logo: <WalletIcons.VultisigText />,
    provider: "Vultisig",
  },
  {
    description:
      "A secure, open-source browser extension and mobile app wallet supporting multiple chains. Key features include multichain account management, staking, voting, and hardware wallet support.",
    links: [
      {
        url: "https://www.keplr.app/",
        icon: <LinkConnect />,
      },
      {
        url: "https://twitter.com/keplrwallet",
        icon: <X />,
      },
    ],
    logo: <WalletIcons.KeplrText />,
    provider: "Keplr",
  },
  {
    description:
      "Brave Wallet is a secure crypto wallet, built right into the Brave privacy browser. No extension required.",
    links: [
      {
        url: "https://brave.com/wallet/",
        icon: <LinkConnect />,
      },
    ],
    logo: <WalletIcons.BraveText />,
    provider: "Brave",
  },
  {
    description:
      "The safest, easiest wallet for over 2,300 chains.  Import addresses, swap and bridge tokens and NFTs, and manage gas fees across multiple chains. Audited by FYEO.",
    links: [
      {
        url: "https://ctrl.xyz/",
        icon: <LinkConnect />,
      },
      {
        url: "https://x.com/ctrl_wallet",
        icon: <X />,
      },
      {
        url: "https://discord.gg/ctrlwallet",
        icon: <Discord />,
      },
      {
        url: "https://t.me/ctrl_wallet",
        icon: <Telegram />,
      },
    ],
    logo: <WalletIcons.CtrlText />,
    provider: "Ctrl",
  },
  {
    description:
      "Coinbase Wallet is a self-custody crypto wallet, putting you in control of your crypto, keys, and data. Now you can safely store your crypto and rare NFTs in one place.",
    links: [
      {
        url: "https://www.coinbase.com/en-gb/wallet",
        icon: <LinkConnect />,
      },
      {
        url: "https://x.com/coinbaseuk",
        icon: <X />,
      },
    ],
    logo: <WalletIcons.CoinbaseText />,
    provider: "Coinbase",
  },
  {
    description:
      "Supports 70+ Cosmos chains and offers address management, simplified chain management and 100% non-custodial security. Extensions for Chrome, Edge and Brave, and apps on iOS and Android are available. Audited by Halborn. Staking, single-click reward claims and airdrops updated in-wallet.",
    links: [
      {
        url: "https://www.leapwallet.io/",
        icon: <LinkConnect />,
      },
      {
        url: "https://twitter.com/leap_cosmos",
        icon: <X />,
      },
    ],
    logo: <WalletIcons.LeapText />,
    provider: "Leap",
  },
  {
    description:
      "An Ethereum wallet trusted by millions. Browser extensions for Chrome, Edge, Firefox, Brave and Opera, or iOS and Android app. Customization available using community-built Snaps.  Manage your portfolio through their web portal.",
    links: [
      {
        url: "https://metamask.io/",
        icon: <LinkConnect />,
      },
      {
        url: "https://github.com/MetaMask/metamask-extension/",
        icon: <GitHub />,
      },
    ],
    logo: <WalletIcons.MetaMaskText />,
    provider: "Metamask",
  },
  {
    description:
      "A universal wallet available on app, web, and extension. Easily access 3,000+ crypto, 80+ networks, thousands of DApps, and the Web3 ecosystem. Supports EVM and non-EVM networks.",
    links: [
      {
        url: "https://chromewebstore.google.com/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge",
        icon: <LinkConnect />,
      },
    ],
    logo: <WalletIcons.OKXText />,
    provider: "Okx",
  },
  {
    description:
      "Rabby Wallet is an open-source browser plugin and mobile app for the DeFi ecosystem, providing users with a better-to-use and more secure multi-chain experience.",
    links: [
      {
        url: "https://rabby.io/",
        icon: <LinkConnect />,
      },
      {
        url: "https://twitter.com/Rabby_io",
        icon: <X />,
      },
      {
        url: "https://github.com/RabbyHub/Rabby",
        icon: <GitHub />,
      },
      {
        url: "https://discord.gg/seFBCWmUre",
        icon: <Discord />,
      },
    ],
    logo: <WalletIcons.RabbyText />,
    provider: "Rabby",
  },
  {
    description:
      "Tonkeeper is your very personal wallet. Receive, buy and spend crypto with ease.",
    links: [
      {
        url: "https://tonkeeper.com/",
        icon: <LinkConnect />,
      },
      {
        url: "https://twitter.com/tonkeeper",
        icon: <X />,
      },
      {
        url: "https://github.com/tonkeeper",
        icon: <GitHub />,
      },
      {
        url: "https://discord.gg/DyQERhN7qV",
        icon: <Discord />,
      },
    ],
    logo: <WalletIcons.TonKeeperText />,
    provider: "Ton",
  },
  {
    description: "TronLink",
    links: [
      // {
      //   url: "https://tonkeeper.com/",
      //   icon: <LinkConnect />,
      // },
      // {
      //   url: "https://twitter.com/tonkeeper",
      //   icon: <X />,
      // },
      // {
      //   url: "https://github.com/tonkeeper",
      //   icon: <GitHub />,
      // },
      // {
      //   url: "https://discord.gg/DyQERhN7qV",
      //   icon: <Discord />,
      // },
    ],
    logo: <WalletIcons.Tronlink />,
    provider: "Tronlink",
  },
  {
    description:
      "A multi-chain wallet with over 140 million users. Available as a browser extension and mobile app. Integrated with Coinbase Pay and Binance Pay. Offers proactive risk notifications and multi-lingual support. Private Keys stored on your device and encrypted with an AES algorithm.",
    links: [
      {
        url: "https://trustwallet.com/browser-extension",
        icon: <LinkConnect />,
      },
    ],
    logo: <WalletIcons.TrustText />,
    provider: "Trust",
  },
  {
    description:
      "The All-in-One XRP Ledger & Xahau Experience. Managing your non custodial accounts & tokens was never this easy. With an entire ecosystem & integrations available in Xaman, you'll have total freedom managing and using your native assets and any other issued token / currency on the supported XRP Ledger protocol networks.",
    links: [
      {
        url: "https://xaman.app",
        icon: <LinkConnect />,
      },
      {
        url: "https://x.com/xamanwallet",
        icon: <X />,
      },
    ],
    logo: <WalletIcons.XamanText />,
    provider: "Xaman",
  },
];

export const Connect = () => {
  const { accounts } = useAccounts();
  const connected = options.filter(
    (o) => !!accounts?.find((a) => a.provider === o.provider)
  );
  const disconnected = options.filter(
    (o) => !accounts?.find((a) => a.provider === o.provider)
  );
  return (
    <div className="rujira__main rujira__main--gradient">
      <div className="rujira__inner rujira__inner--pad">
        {connected.length ? (
          <h1 className="h2">Your connected Wallets</h1>
        ) : (
          <h1 className="h1">Connect your Wallets</h1>
        )}
        <div className="row wrap pad gap-y-4">
          {connected.map((x) => (
            <WalletOption key={x.description} {...x} />
          ))}
        </div>

        {connected.length ? (
          <h2 className="h2 mt-6">Connect your Wallets</h2>
        ) : null}

        <div className="gradient-card-container mt-6">
          <div className="gradient-card gradient-card--purple p-4 bg-black flex dir-c ai-s">
            <WalletIcons.StationText className="h-8" />
            <p className="p color-grey mt-2 mb-0">
              A secure and convenient multi-chain wallet with deep integration
              into the Rujira ecosystem and lots of features Sonar users will
              recognise! Lend, borrow, trade, bid, liquidate and more from your
              phone. Compatible with any desktop browser. Unlock Rujira's DeFi
              capability wherever, whenever. <strong>Coming soon...</strong>
            </p>
            {/* <Button
            label="Coming Soon..."
            className="button--outline button--big button--icon-right"></Button> */}
          </div>
        </div>
        <div className="row wrap pad gap-y-4 mt-4">
          {disconnected.map((x) => (
            <WalletOption key={x.description} {...x} />
          ))}
        </div>
      </div>
    </div>
  );
};
